var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTile = function SvgTile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 4a2 2 0 0 1 2 2v12a2 2 0 0 1-1.796 1.99L21 20H3l-.204-.01a2 2 0 0 1-1.785-1.786L1 18V6a2 2 0 0 1 2-2zM3 5.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h2v-13zm3.5 13H21a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5H6.5z",
    clipRule: "evenodd"
  })));
};
export default SvgTile;